'use client';

import { createContext, useContext } from 'react';

/** Set from server layout so SSR + client agree (avoids NODE_ENV bundle mismatches). */
const HousePromoDevContext = createContext(false);

export function HousePromoDevProvider({
  value,
  children,
}: {
  value: boolean;
  children: React.ReactNode;
}) {
  return <HousePromoDevContext.Provider value={value}>{children}</HousePromoDevContext.Provider>;
}

export function useHousePromoDevFromLayout() {
  return useContext(HousePromoDevContext);
}
